import { render, staticRenderFns } from "./ActiveLoadsPanel.vue?vue&type=template&id=5c40b523&scoped=true"
import script from "./ActiveLoadsPanel.vue?vue&type=script&lang=js"
export * from "./ActiveLoadsPanel.vue?vue&type=script&lang=js"
import style0 from "./ActiveLoadsPanel.vue?vue&type=style&index=0&id=5c40b523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40b523",
  null
  
)

export default component.exports